export default __webpack_public_path__ + "static/media/Category=Kino.6981c547.png";